module.exports = __webpack_public_path__ + "img/truemoney.439d742a.png";